import { Box, Chip, Grid, Stack, Typography } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'

import { RailVisitTrackAndTimingFormStore } from '@planning/pages/RailVisit/stores/RailVisitTrackAndTimingFormStore'
import { useTranslate } from '@tolgee/react'
import { SuccessIcon, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

type Props = { store: RailVisitTrackAndTimingFormStore }

export const RailVisitPlanningTrackSelector: FC<Props> = observer(({ store }) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const { railTrackItemStore } = usePlanningStore()

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <Typography variant='subtitle1'>{t('tracksSelection', 'Tracks selection')}</Typography>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Stack flexDirection='row' alignItems='center' gap={theme.customSpacing.xxxs}>
          <Typography variant='subtitle2'>{t('track', 'Track')}</Typography>
          <Typography sx={{ color: `${theme.palette.error.main} !important` }}> *</Typography>
        </Stack>
        <Box display='flex' gap={1} mt={1}>
          <Stack direction='row' gap={1} mb={1} flexWrap='wrap'>
            {railTrackItemStore.activeRailTracks.map(railTrack => {
              const isSelected = store.railTracks.value?.map(r => r.id).includes(railTrack.id)

              return (
                <Chip
                  data-cy={`rail-track-chip-${railTrack.name}`}
                  key={`railTrack_chip_${railTrack.id}`}
                  label={railTrack.name}
                  icon={isSelected ? <SuccessIcon /> : undefined}
                  color={isSelected ? 'primary' : 'default'}
                  onClick={() => {
                    const currentValues = store.railTracks.value ?? []

                    if (isSelected) {
                      store.railTracks.setValue(currentValues.filter(r => r.id !== railTrack.id))
                    } else {
                      store.railTracks.setValue([...currentValues, railTrack])
                    }
                  }}
                />
              )
            })}
          </Stack>
        </Box>
      </Grid>

      {store.railTracks.error && (
        <Grid mt={-2} size={{ xs: 12 }}>
          <Typography variant='caption' color='error'>
            {t('fieldIsRequired', 'Field is required.')}
          </Typography>
        </Grid>
      )}
    </>
  )
})
